import React, { Component } from 'react';

import Modal from '../modal';
import Autopilot from '../../containers/purchase-dashboard/autopilot/index.container';
import AutopilotOn from '../../containers/purchase-dashboard/autopilot/autopilot.on.container';
import InvitePeople from '../../containers/invite-people/index.container';
import InviteConfirmation from '../../containers/invite-people/invite-confirmation.container';
import MakeChanges from '../../containers/edit-purchase/index.container';
import CancelPurchase from '../../containers/cancel-purchase.container';
import WithdrawFromPurchase from '../../containers/withdraw-from-purchase.container';
import RemoveFromPurchase from '../../containers/remove-from-purchase.container';
import CommitToPurchase from '../../containers/purchase-dashboard/commit.container';
import EditCommit from '../../containers/purchase-dashboard/commit.edit.container';
import CoverDifferenceCommit from '../../containers/purchase-dashboard/commit.cover-difference.container';
import ResolvePaymentIssues from '../../containers/resolve-payment-issues.container';
import PurchaseImageMagnifier from '../../containers/purchase-dashboard/purchase-image-magnifier.container';

import isMobile from '../../../vendor/detect-mobile';

import '../../css/commit-modal.css';

class DashboardModals extends Component {
  constructor(props) {
    super(props);
    this.hideAutoPilotModal = this.hideAutoPilotModal.bind(this);
    this.hideImageMagnifierModal = this.hideImageMagnifierModal.bind(this);
  }

  get showingImageMagnifierModal() { return this.props.isImageMagnifierModalVisible; }

  showingAutoPilotModal() {
    return this.props.isAutoPilotModalVisible;
  }

  showingAutoPilotOnModal() {
    return this.props.isAutoPilotOnModalVisible;
  }

  showingInvitePeopleModal() {
    return this.props.isInvitePeopleModalVisible;
  }

  showingInviteConfirmationModal() {
    return this.props.isInviteConfirmationModalVisible;
  }

  showingMakeChangesModal() {
    return this.props.isMakeChangesModalVisible;
  }

  showingCancelPurchaseModal() {
    return this.props.isCancelPurchaseModalVisible;
  }

  showingWithdrawModal() {
    return this.props.isWithdrawModalVisible;
  }

  showingRemoveModal() {
    return this.props.isRemoveModalVisible;
  }

  showingCommitToPurchaseModal() {
    return this.props.isCommitToPurchaseVisible;
  }

  showingEditCommitModal() {
    return this.props.isEditCommitVisible;
  }

  showingCoverDifferneceModal() {
    return this.props.isCoverDifferenceVisible;
  }

  showingResolveIssuesModal() {
    return this.props.isResolveIssuesModalVisible;
  }

  hideAutoPilotModal() {
    const { purchase } = this.props;

    this.props.hideAutoPilotModal(purchase.id);
  }

  hideImageMagnifierModal() { this.props.hideImageMagnifierModal(); }

  redirectToCommitIfMobile(params = '') {
    const { purchase: { slug } } = this.props;

    if (isMobile) {
      window.location = `/m/purchases/${slug}/commit${params}`;

      return true;
    }

    return false;
  }

  renderAutoPilotModal() {
    if (!this.showingAutoPilotModal()) return null;

    return (
      <Modal width="autopilot-modal" onClose={this.hideAutoPilotModal}>
        <Autopilot />
      </Modal>
    );
  }

  renderAutoPilotOnModal() {
    if (!this.showingAutoPilotOnModal()) return null;

    return (
      <Modal width="modal-md" onClose={this.props.hideAutoPilotOnModal}>
        <AutopilotOn />
      </Modal>
    );
  }

  renderInvitePeopleModal() {
    if (!this.showingInvitePeopleModal()) return null;

    return (
      <Modal width="invites-modal" onClose={this.props.hideInviteModal}>
        <InvitePeople />
      </Modal>
    );
  }

  renderInviteConfirmationModal() {
    if (!this.showingInviteConfirmationModal()) return null;

    return (
      <Modal width="invites-confirmation-modal" onClose={this.props.hideInviteConfirmationModal}>
        <InviteConfirmation />
      </Modal>
    );
  }

  renderMakeChangesModal() {
    if (!this.showingMakeChangesModal()) return null;

    return (
      <Modal width="edit-purchase-modal" onClose={this.props.hideMakeChangesModal}>
        <MakeChanges />
      </Modal>
    );
  }

  renderCancelPurchaseModal() {
    if (!this.showingCancelPurchaseModal()) return null;

    return (
      <Modal width="cancel-purchase-modal" onClose={this.props.hideCancelPurchaseModal}>
        <CancelPurchase />
      </Modal>
    );
  }

  renderWithdrawModal() {
    if (!this.showingWithdrawModal()) return null;

    return (
      <Modal width="withdraw-modal" onClose={this.props.hideWithdrawModal}>
        <WithdrawFromPurchase />
      </Modal>
    );
  }

  renderCommitToPurchaseModal() {
    if (!this.showingCommitToPurchaseModal()) return null;
    if (this.redirectToCommitIfMobile()) return null;

    return (
      <Modal width="commit-modal modal-lg" onClose={this.props.hideCommitModal}>
        <CommitToPurchase />
      </Modal>
    );
  }

  renderEditCommitModal() {
    if (!this.showingEditCommitModal()) return null;
    if (this.redirectToCommitIfMobile()) return null;

    return (
      <Modal width="commit-modal modal-lg" onClose={this.props.hideEditCommitModal}>
        <EditCommit />
      </Modal>
    );
  }

  renderCoverDifferenceModal() {
    if (!this.showingCoverDifferneceModal()) return null;
    if (this.redirectToCommitIfMobile('#cover')) return null;

    return (
      <Modal width="commit-modal modal-lg" onClose={this.props.hideCoverDifferenceModal}>
        <CoverDifferenceCommit />
      </Modal>
    );
  }

  renderRemoveModal() {
    if (!this.showingRemoveModal()) return null;

    return (
      <Modal width="remove-modal" onClose={this.props.hideRemoveModal}>
        <RemoveFromPurchase />
      </Modal>
    );
  }

  renderResolvePaymentIssuesModal() {
    if (!this.showingResolveIssuesModal()) return null;

    return (
      <Modal width="resolve-payment-issues-modal modal-lg" onClose={this.props.hideResolveIssuesModal}>
        <ResolvePaymentIssues />
      </Modal>
    );
  }

  renderImageMagnifierModal() {
    if (!this.showingImageMagnifierModal) return null;

    return (
      <Modal width="image-magnifier-modal" onClose={this.hideImageMagnifierModal}>
        <PurchaseImageMagnifier />
      </Modal>
    );
  }

  render() {
    return (
      <div className="dashboard-modals">
        {this.renderAutoPilotModal()}
        {this.renderAutoPilotOnModal()}
        {this.renderInvitePeopleModal()}
        {this.renderInviteConfirmationModal()}
        {this.renderMakeChangesModal()}
        {this.renderCancelPurchaseModal()}
        {this.renderWithdrawModal()}
        {this.renderCommitToPurchaseModal()}
        {this.renderEditCommitModal()}
        {this.renderCoverDifferenceModal()}
        {this.renderRemoveModal()}
        {this.renderResolvePaymentIssuesModal()}
        {this.renderImageMagnifierModal()}
      </div>
    );
  }
}

export default DashboardModals;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/modals.js